import usePageTranslation from "../../../hooks/ui/usePageTranslation";
import { sanitizeHtml } from '../../../util/sanitizeHtml';
import { useAppSelector } from "../../../hooks/redux";
import { selectTranslationEditFlag } from "../../../api-integration/common.slice";
import { getPageByURL, getTranslatedText } from "../../../util/util";
import EditTranslationIcon from "../edit-translation-icon/EditTranslationIcon";
import { useLocation } from "react-router-dom";
import { useTheme } from "../../../theme/ThemeContext";

const Footer = () => {
  const {theme} = useTheme();
  const PageTranslation = usePageTranslation();
  const TranslationEditFlag = useAppSelector(selectTranslationEditFlag);
  const location = useLocation();
  const footerPageName = getPageByURL(location.pathname);
  
  return (
    <>
    {(footerPageName === 'login' || footerPageName === 'eventLogin') ? null : (
      <footer className="">
        <div className="text-center text-lg-end p-3 p-lg-5 me-lg-5 text-nowrap">
          {[
            theme?.aboutURL?.length > 0 && {
              url: theme.aboutURL,
              key: 'about.text'
            },
            theme?.contactURL?.length > 0 && {
              url: theme.contactURL,
              key: 'contact.text'
            },
            theme?.termsURL?.length > 0 && {
              url: theme.termsURL,
              key: 'terms.text'
            },
            theme?.privacyURL?.length > 0 && {
              url: theme.privacyURL,
              key: 'privacy.text'
            },
          ]
            .filter((item): item is { url: string; key: string } => Boolean(item))
            .map((item, index, arr) => (
              <span key={item.key}>
                <a
                  className="h6 text-decoration-none"
                  target="_blank"
                  rel="noopener noreferrer"
                  href={item.url}
                >
                  <span dangerouslySetInnerHTML={{ __html: sanitizeHtml(getTranslatedText(item.key, PageTranslation)) }} />
                </a>
                {TranslationEditFlag && <EditTranslationIcon translationKey={item.key} translationType='text'/>}
                {index < arr.length - 1 && " | "}
              </span>
            ))}
        </div>
        <div className="text-center mb-3">
          <small>
            {getTranslatedText('poweredByBlueCallom.text',PageTranslation)}
            {TranslationEditFlag && <EditTranslationIcon translationKey='poweredByBlueCallom.text' translationType='text'/>}
          </small>
        </div>
      </footer>
    )}
    </>
  )
}

export default Footer;